module.exports = __webpack_public_path__ + "img/mypath_use_logo.cc50189e.svg";